import React, { Component } from 'react';
import classNames from 'classnames';
import './styles.scss';

class Modal extends Component {
    render() {
        return (
            <div className={classNames({
                'modal': true,
                'modal--is-open': this.props.isOpen,
                ...this.props.modifiers
            })}>
                {this.props.children}
            </div>
        );
    }
};

export default Modal;